export default "__VITE_ASSET__DkC2xz3f__"